import Link from '@tiptap/extension-link'

export const CustomLink = Link.extend({
  addKeyboardShortcuts() {
    return {
      'Mod-k': () =>
        this.editor.isActive('link')
          ? this.editor.chain().focus().extendMarkRange('link').unsetLink().run()
          : this.editor
              .chain()
              .focus()
              .extendMarkRange('link')
              .setLink({ href: '', target: '_blank' })
              .setTextSelection(this.editor.view.state.selection.to)
              .run(),
    }
  },
})
